import React, { useState } from 'react';

const DeviceConnectionsView = () => {
    const [devices, setDevices] = useState(() => JSON.parse(localStorage.getItem('connectedDevices') || '[]'));
    const [message, setMessage] = useState('');
    const [fileData, setFileData] = useState(null);

    const saveDevice = (device) => {
        const next = [...devices.filter(item => item.id !== device.id), device];
        setDevices(next);
        localStorage.setItem('connectedDevices', JSON.stringify(next));
    };

    const connectBluetooth = async () => {
        if (!navigator.bluetooth) {
            setMessage('Bluetooth Web non disponible dans ce navigateur. Utilisez Chrome/Edge ou la passerelle locale.');
            return;
        }
        try {
            const device = await navigator.bluetooth.requestDevice({ acceptAllDevices: true, optionalServices: [] });
            saveDevice({ id: device.id, name: device.name || 'Appareil Bluetooth', transport: 'Bluetooth', status: 'Sélectionné, protocole à configurer' });
            setMessage(`${device.name || 'Appareil Bluetooth'} est sélectionné. Le profil BLE doit être compatible pour lire les mesures.`);
        } catch (error) {
            if (error.name !== 'NotFoundError') setMessage(`Connexion Bluetooth interrompue: ${error.message}`);
        }
    };

    const connectUsb = async () => {
        if (!navigator.usb) {
            setMessage('USB Web non disponible dans ce navigateur. Utilisez Chrome/Edge ou la passerelle locale.');
            return;
        }
        try {
            const device = await navigator.usb.requestDevice({ filters: [] });
            saveDevice({ id: `${device.vendorId}-${device.productId}`, name: 'Appareil USB', transport: 'USB', status: 'Sélectionné, pilote/protocole à configurer' });
            setMessage('Appareil USB sélectionné. Le protocole du fabricant doit être connu pour lire les données.');
        } catch (error) {
            if (error.name !== 'NotFoundError') setMessage(`Connexion USB interrompue: ${error.message}`);
        }
    };

    const connectSerial = async () => {
        if (!navigator.serial) {
            setMessage('Port série Web non disponible. Utilisez Chrome/Edge ou la passerelle locale.');
            return;
        }
        try {
            const port = await navigator.serial.requestPort();
            await port.open({ baudRate: 9600 });
            saveDevice({ id: `serial-${Date.now()}`, name: 'Port série USB', transport: 'USB/série', status: 'Connecté, lecture à configurer' });
            setMessage('Port série ouvert. Le débit et le format du fabricant doivent être configurés.');
            await port.close();
        } catch (error) {
            setMessage(`Connexion série interrompue: ${error.message}`);
        }
    };

    const importMeasurement = (event) => {
        const file = event.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            setFileData({ name: file.name, content: String(reader.result).slice(0, 5000) });
            setMessage(`Fichier ${file.name} importé. Vérifiez les mesures avant de les ajouter au dossier patient.`);
        };
        reader.readAsText(file);
    };

    return (
        <div style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
            <h2>Connexion des appareils médicaux</h2>
            <p>La marque n'est pas imposée. Choisissez le transport disponible sur l'appareil, puis configurez son protocole de mesure.</p>
            <p><strong>Important:</strong> une connexion technique ne garantit pas que les mesures sont lisibles. Chaque appareil doit être testé et validé avant usage clinique.</p>
            <section style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))', margin: '20px 0' }}>
                <button type="button" onClick={connectBluetooth} style={{ padding: '18px' }}>Bluetooth BLE</button>
                <button type="button" onClick={connectUsb} style={{ padding: '18px' }}>USB Web</button>
                <button type="button" onClick={connectSerial} style={{ padding: '18px' }}>USB / Port série</button>
                <label style={{ padding: '18px', border: '1px solid #ccc', borderRadius: '4px' }}>Importer résultat CSV/XML/PDF<input type="file" accept=".csv,.xml,.txt,.json,.pdf" onChange={importMeasurement} style={{ display: 'block', marginTop: '8px' }} /></label>
            </section>
            {message && <div style={{ padding: '12px', backgroundColor: '#eef6ff', border: '1px solid #bfdbfe', borderRadius: '8px' }}>{message}</div>}
            {fileData && <pre style={{ whiteSpace: 'pre-wrap', padding: '12px', backgroundColor: '#f8fafc', marginTop: '12px' }}>{fileData.content}</pre>}
            <section style={{ marginTop: '24px' }}>
                <h3>Appareils sélectionnés</h3>
                {devices.length ? devices.map(device => <div key={device.id} style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}><strong>{device.name}</strong> · {device.transport}<br /><small>{device.status}</small></div>) : <p>Aucun appareil enregistré.</p>}
            </section>
        </div>
    );
};

export default DeviceConnectionsView;
